export type ToastType = 'info' | 'success' | 'warning' | 'error';

export const toastClass = 'zenity-toast-container';

export const successConfig = (type: ToastType) => ({
  toastClass: `ngx-toastr ${type}-snackbar ${toastClass}`,
  autoDismiss: false,
  disableTimeOut: false,
  timeOut: 15000,
  tapToDismiss: true,
  closeButton: true,
});

export const errorConfig = (type: ToastType) => ({
  toastClass: `ngx-toastr ${type}-snackbar ${toastClass}`,
  autoDismiss: false,
  disableTimeOut: true,
  tapToDismiss: true,
  closeButton: true,
});
